import { cfetch } from '@confluence/network';
import { isLocal } from '@confluence/ssr-utilities/entry-points/env.ts';

export const postJson = (url: string, data: any): Promise<any> => {
	const fetchOptions = {
		method: 'POST',
		headers: {
			'Content-Type': 'application/json',
		},
		body: JSON.stringify(data),
	};

	return cfetch(url, fetchOptions).then((response) => {
		return response.json();
	});
};

export const fetchJSON = (url: string): Promise<any> => {
	const fetchOptions = {
		method: 'GET',
		headers: {
			Accept: 'application/json',
			// eslint-disable-next-line check-react-ssr-usage/no-react-ssr
			...(Boolean(process.env.REACT_SSR) &&
			Boolean(process.env.BIFROST_TEMPLATE_BUILD) &&
			!isLocal()
				? { 'x-ssr-service-name': 'identity-platform' }
				: {}),
		},
	};
	return cfetch(url, fetchOptions).then((response) => {
		return response.json();
	});
};
